import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Component, Input, PLATFORM_ID, Optional, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1$2 from '@angular/router';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i1$1 from '@angular/platform-browser';
import * as i4 from '@ngx-translate/core';
import { TranslatePipe, TranslateDirective, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import * as i4$1 from '@angular/common';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { from } from 'rxjs';

const STRAPI_CONFIG = new InjectionToken('STRAPI_CONFIG');
class StrapiService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this._settings = {};
        this._langs = [];
        this.singletypes = {};
        this.collectiontypes = {};
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this._settings = yield this.getSingleType('settings', null);
            this._langs = yield this.http.get(this.config.url + '/i18n/locales').toPromise();
        });
    }
    getSingleType(id, _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.singletypes[_locale || 'default'] == null)
                this.singletypes[_locale || 'default'] = {};
            if (this.singletypes[_locale || 'default'][id] == null) {
                const params = {};
                if (_locale)
                    params._locale = _locale;
                this.singletypes[_locale || 'default'][id] = yield this.http
                    .get(this.config.url + '/:id'.replace(':id', id), { params })
                    .toPromise();
            }
            return this.singletypes[_locale || 'default'][id];
        });
    }
    getSettings() {
        return this._settings;
    }
    getSetting(key) {
        return this._settings ? this._settings[key] : null;
    }
    getLangs() {
        return this._langs;
    }
    filterCollectionType(collection, q, _start = 0, _limit = 10, _sort = 'id:ASC', _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                _start,
                _limit,
                _sort,
            };
            if (_locale)
                params._locale = _locale;
            return yield this.http.get(this.config.url + '/:collection'.replace(':collection', collection), { params }).toPromise();
        });
    }
    filterNews(q, _start = 0, _limit = 10, _sort = 'id:ASC', _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.filterCollectionType('news', q, _start, _limit, _sort, _locale);
        });
    }
    getCollectionType(collection, id, _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.collectiontypes[collection] == null)
                this.collectiontypes[collection] = {};
            if (this.collectiontypes[collection][_locale || 'default'] == null)
                this.collectiontypes[collection][_locale || 'default'] = {};
            if (this.collectiontypes[collection][_locale || 'default'][id] == null) {
                const params = {};
                if (_locale)
                    params._locale = _locale;
                if (!isNaN(+id)) {
                    this.collectiontypes[collection][_locale || 'default'][id] = yield this.http
                        .get(this.config.url + '/:collection/:id'.replace(':collection', collection).replace(':id', id.toString()), { params })
                        .toPromise();
                }
                else if (id == undefined) {
                    this.collectiontypes[collection][_locale || 'default'][id] = yield this.http
                        .get(this.config.url + '/:collection'.replace(':collection', collection), { params })
                        .toPromise();
                }
                else {
                    // cerco per slug
                    const tmp = yield this.http
                        .get(this.config.url + '/:collection?slug=:id'.replace(':collection', collection).replace(':id', id.toString()), {
                        params,
                    })
                        .toPromise();
                    this.collectiontypes[collection][_locale || 'default'][id] = tmp.length ? tmp[0] : null;
                }
            }
            return this.collectiontypes[collection][_locale || 'default'][id];
        });
    }
    getPage(id, _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getCollectionType('page', id, _locale);
        });
    }
    getNews(id, _locale) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getCollectionType('news', id, _locale);
        });
    }
    getImageUrl(url) {
        return (url.startsWith('/') ? this.config.url : '') + url;
    }
}
StrapiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: StrapiService, deps: [{ token: i1.HttpClient }, { token: STRAPI_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
StrapiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: StrapiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: StrapiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [STRAPI_CONFIG]
                    }] }];
    } });

class MetaService {
    constructor(titleService, metaTagService, strapi) {
        this.titleService = titleService;
        this.metaTagService = metaTagService;
        this.strapi = strapi;
    }
    setTitle(model, settings) {
        this.titleService.setTitle(model.meta ? model.meta.title : settings.meta.title);
    }
    updateTag(model, settings) {
        this.metaTagService.updateTag({
            name: model.meta ? model.meta.title : settings.meta.title,
            content: model.meta ? model.meta.description : settings.meta.description,
        });
    }
    addTags(model, settings) {
        this.metaTagService.addTags([
            { property: 'og:title', content: model.meta ? model.meta.title : settings.meta.title },
            {
                property: 'og:description',
                content: model.meta ? model.meta.description : settings.meta.description,
            },
            { property: 'og:site_name', content: model.meta ? model.meta.title : settings.meta.title },
            { property: 'og:url', content: '' },
            { property: 'og:type', content: 'website' },
            {
                property: 'og:image',
                content: model.meta && model.meta.image ? this.strapi.getImageUrl(model.meta.image.url) : this.strapi.getImageUrl(settings.meta.image.url),
            },
            {
                property: 'og:image:secure_url',
                content: model.meta && model.meta.image ? this.strapi.getImageUrl(model.meta.image.url) : this.strapi.getImageUrl(settings.meta.image.url),
            },
            { property: 'og:image:type', content: 'image/jpeg' },
            { property: 'og:image:width', content: '1200' },
            { property: 'og:image:height', content: '628' },
            { property: 'og:image:alt', content: model.meta ? model.meta.title : settings.meta.title },
            { property: 'author', content: model.meta ? model.meta.title : settings.meta.title },
            { property: 'pinterest', content: 'nohover' },
            { property: 'twitter:title', content: model.meta ? model.meta.title : settings.meta.title },
            { property: 'twitter:description', content: model.meta ? model.meta.description : settings.meta.description },
            { property: 'twitter:card', content: 'player' },
            { property: 'twitter:creator', content: '' },
            { property: 'twitter:domain', content: '' },
        ]);
    }
}
MetaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: MetaService, deps: [{ token: i1$1.Title }, { token: i1$1.Meta }, { token: StrapiService }], target: i0.ɵɵFactoryTarget.Injectable });
MetaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: MetaService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: MetaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Title }, { type: i1$1.Meta }, { type: StrapiService }]; } });

class CollectionTypeListComponent {
    constructor(activatedRoute, router, strapi, meta) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.strapi = strapi;
        this.meta = meta;
        this.model = this.activatedRoute.snapshot.data.model;
        if (!this.model) {
            this.router.navigate(['error', 404], {
                skipLocationChange: true,
            });
        }
        this.settings = this.strapi.getSettings();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.meta.setTitle(this.model, this.settings);
            this.meta.updateTag(this.model, this.settings);
            this.meta.addTags(this.model, this.settings);
        });
    }
}
CollectionTypeListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeListComponent, deps: [{ token: i1$2.ActivatedRoute }, { token: i1$2.Router }, { token: StrapiService }, { token: MetaService }], target: i0.ɵɵFactoryTarget.Component });
CollectionTypeListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: CollectionTypeListComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeListComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.ActivatedRoute }, { type: i1$2.Router }, { type: StrapiService }, { type: MetaService }]; } });
class CollectionTypeListResolver {
    constructor(strapi, translate) {
        this.strapi = strapi;
        this.translate = translate;
    }
    resolve(route) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.strapi.getCollectionType(route.data.id, route.params.id, this.translate.currentLang);
        });
    }
}
CollectionTypeListResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeListResolver, deps: [{ token: StrapiService }, { token: i4.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
CollectionTypeListResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeListResolver });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeListResolver, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StrapiService }, { type: i4.TranslateService }]; } });

class CollectionTypeComponent {
    constructor(route, router, strapi, meta) {
        this.route = route;
        this.router = router;
        this.strapi = strapi;
        this.meta = meta;
        this.model = this.route.snapshot.data.model;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        if (!this.model) {
            this.router.navigate(['error', 404], {
                skipLocationChange: true,
            });
        }
        this.settings = this.strapi.getSettings();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.meta.setTitle(this.model, this.settings);
            this.meta.updateTag(this.model, this.settings);
            this.meta.addTags(this.model, this.settings);
        });
    }
}
CollectionTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeComponent, deps: [{ token: i1$2.ActivatedRoute }, { token: i1$2.Router }, { token: StrapiService }, { token: MetaService }], target: i0.ɵɵFactoryTarget.Component });
CollectionTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: CollectionTypeComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.ActivatedRoute }, { type: i1$2.Router }, { type: StrapiService }, { type: MetaService }]; } });
class CollectionTypeResolver {
    constructor(strapi, translate) {
        this.strapi = strapi;
        this.translate = translate;
    }
    resolve(route) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.strapi.getCollectionType(route.data.id, route.params.id, this.translate.currentLang);
            }
            catch (error) {
                console.error(error);
                return null;
            }
        });
    }
}
CollectionTypeResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeResolver, deps: [{ token: StrapiService }, { token: i4.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
CollectionTypeResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeResolver });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CollectionTypeResolver, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StrapiService }, { type: i4.TranslateService }]; } });

class SingleTypeComponent {
    constructor(route, router, strapi, translate, meta) {
        this.route = route;
        this.router = router;
        this.strapi = strapi;
        this.translate = translate;
        this.meta = meta;
        this.webpage = {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
        };
        this.meta_enabled = true;
        this.model = this.route.snapshot.data.model;
        if (!this.model) {
            this.router.navigate(['error', 404], {
                skipLocationChange: true,
            });
        }
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.settings = this.strapi.getSettings();
            this.webpage.name = this.model.meta ? this.model.meta.title : this.settings.meta.title;
            this.webpage.description = this.model.meta ? this.model.meta.description : this.settings.meta.description;
            if (this.meta_enabled) {
                this.meta.setTitle(this.model, this.settings);
                this.meta.updateTag(this.model, this.settings);
                this.meta.addTags(this.model, this.settings);
            }
        });
    }
}
SingleTypeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SingleTypeComponent, deps: [{ token: i1$2.ActivatedRoute }, { token: i1$2.Router }, { token: StrapiService }, { token: i4.TranslateService }, { token: MetaService }], target: i0.ɵɵFactoryTarget.Component });
SingleTypeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: SingleTypeComponent, selector: "ng-component", inputs: { meta_enabled: "meta_enabled" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SingleTypeComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.ActivatedRoute }, { type: i1$2.Router }, { type: StrapiService }, { type: i4.TranslateService }, { type: MetaService }]; }, propDecorators: { meta_enabled: [{
                type: Input
            }] } });
class SingleTypeResolver {
    constructor(strapi, translate) {
        this.strapi = strapi;
        this.translate = translate;
    }
    resolve(route) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.strapi.getSingleType(route.data.id, this.translate.currentLang);
            }
            catch (error) {
                console.error(error);
                return null;
            }
        });
    }
}
SingleTypeResolver.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SingleTypeResolver, deps: [{ token: StrapiService }, { token: i4.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
SingleTypeResolver.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SingleTypeResolver });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SingleTypeResolver, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StrapiService }, { type: i4.TranslateService }]; } });

class CookieService {
    // cookieStore: any;
    constructor(platformId, req) {
        var _a;
        this.platformId = platformId;
        this.req = req;
        this.cookieStore = {};
        const cookies = isPlatformServer(this.platformId) ? (_a = this.req) === null || _a === void 0 ? void 0 : _a.headers.cookie : document.cookie;
        if (cookies) {
            for (const cookie of cookies.split(';')) {
                const cookieArr = cookie.split('=');
                this.cookieStore[cookieArr[0].trim()] = cookieArr[1].trim();
            }
        }
        // console.debug('cookies', this.cookieStore);
    }
    get(key) {
        return this.cookieStore[key];
    }
    set(name, value, expireDays, path) {
        if (isPlatformBrowser(this.platformId)) {
            let cookie = `${name}=${value}`;
            if (expireDays) {
                const d = new Date();
                d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
                cookie += `; expires=${d.toUTCString()}`;
            }
            if (path)
                cookie += `; path=${path}`;
            document.cookie = cookie;
            // console.log(document.cookie);
        }
    }
}
CookieService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CookieService, deps: [{ token: PLATFORM_ID }, { token: REQUEST, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
CookieService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CookieService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: CookieService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }, { type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [REQUEST]
                    }] }];
    } });

class CustomLoader {
    constructor(strapi) {
        this.strapi = strapi;
    }
    getTranslation(lang) {
        return from(this.strapi.getSingleType('locales', lang).then((result) => result.values));
    }
}
class TranslateInitService {
    constructor(route, translate, cookieService, location, strapi, platformId) {
        this.route = route;
        this.translate = translate;
        this.cookieService = cookieService;
        this.location = location;
        this.strapi = strapi;
        this.platformId = platformId;
        // console.debug('TRANSLATE_CONFIG', config);
    }
    getCurrentParams() {
        let params = new HttpParams();
        // riprendo i parametri gia presenti, se ce ne sono
        console.log('get current params');
        console.log(this.route.snapshot.queryParams);
        for (const key in this.route.snapshot.queryParams) {
            console.log('get current params key');
            console.log(key);
            params = params.set(key, this.route.snapshot.queryParams[key]);
        }
        return params;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.translate.addLangs(this.strapi.getLangs().map((lang) => lang.code));
            console.debug('Available langs:', this.translate.getLangs());
            // console.log('DEFAULT LANGUAGE: ' + this.config.default);
            const _tmp_default = this.strapi.getLangs().find((lang) => lang.isDefault);
            if (_tmp_default) {
                this.translate.setDefaultLang(_tmp_default.code);
                console.debug('Default lang set to:', this.translate.getDefaultLang());
            }
            let lang2use = this.translate.getDefaultLang();
            this.route.queryParams.subscribe((params) => __awaiter(this, void 0, void 0, function* () {
                if (params.hl && this.translate.getLangs().includes(params.hl)) {
                    yield this.translate.use(params.hl).toPromise();
                }
            }));
            if (this.cookieService.get('lang') && this.translate.getLangs().includes(this.cookieService.get('lang'))) {
                console.debug('Cookie lang:', this.cookieService.get('lang'));
                lang2use = this.cookieService.get('lang');
            }
            else if (isPlatformBrowser(this.platformId) && this.translate.getBrowserLang() && this.translate.getLangs().includes(this.translate.getBrowserLang())) {
                console.debug('Browser lang is:', this.translate.getBrowserLang());
                lang2use = this.translate.getBrowserLang();
            }
            //this.route.queryParams.subscribe(async (params) => {
            //if (params['hl'] && this.translate.getLangs().includes(params['hl'])) {
            //       await this.translate.use(params['hl']).toPromise();
            //}
            //});
            this.langChangeSubscription = this.translate.onLangChange.subscribe((event) => {
                if (isPlatformBrowser(this.platformId)) {
                    localStorage.setItem('lang', this.translate.currentLang);
                    this.cookieService.set('lang', this.translate.currentLang);
                    // aggiungo o sovrascrivo il parametro hl
                    // let params: HttpParams = this.getCurrentParams().set('hl', this.translate.currentLang);
                    // // aggiorno l'url
                    // this.location.replaceState(this.location.path().split('?')[0], params.toString());
                    // console.log(this.location.path());
                }
                console.debug('Current lang changed to:', this.translate.currentLang);
            });
            yield this.translate.use(lang2use).toPromise();
        });
    }
}
TranslateInitService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: TranslateInitService, deps: [{ token: i1$2.ActivatedRoute }, { token: i4.TranslateService }, { token: CookieService }, { token: i4$1.Location }, { token: StrapiService }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
TranslateInitService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: TranslateInitService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: TranslateInitService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: i1$2.ActivatedRoute }, { type: i4.TranslateService }, { type: CookieService }, { type: i4$1.Location }, { type: StrapiService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }];
    } });

class NgCommonStrapiModule {
    static forRoot(config = {}) {
        return {
            ngModule: NgCommonStrapiModule,
            providers: [
                CookieService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: (strapi, translateInitService) => {
                        return () => {
                            return strapi.init().then(() => translateInitService.init());
                        };
                    },
                    multi: true,
                    deps: [StrapiService, TranslateInitService],
                },
                { provide: STRAPI_CONFIG, useValue: config.strapi || {} },
                // { provide: TRANSLATE_CONFIG, useValue: config.translate || { } },
                // { provide: COOKIE_SERVICE, useValue: config.cookie },
            ]
        };
    }
}
NgCommonStrapiModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: NgCommonStrapiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgCommonStrapiModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: NgCommonStrapiModule, imports: [i4.TranslateModule], exports: [TranslatePipe,
        TranslateDirective] });
NgCommonStrapiModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: NgCommonStrapiModule, imports: [[
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: (strapi) => {
                        return new CustomLoader(strapi);
                    },
                    deps: [StrapiService],
                },
            }),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: NgCommonStrapiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: (strapi) => {
                                    return new CustomLoader(strapi);
                                },
                                deps: [StrapiService],
                            },
                        }),
                    ],
                    exports: [
                        TranslatePipe,
                        TranslateDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of ng-common-strapi
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CollectionTypeComponent, CollectionTypeListComponent, CollectionTypeListResolver, CollectionTypeResolver, CookieService, CustomLoader, MetaService, NgCommonStrapiModule, STRAPI_CONFIG, SingleTypeComponent, SingleTypeResolver, StrapiService, TranslateInitService };
